export enum UserProtectionLimitFilter {
  UNLIMITED = "unlimited",
  LIMITED = "limited",
}
